import React from 'react';

export const AddToPlaylist = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.4531 0.249152C20.1406 0.0147771 19.75 -0.0633479 19.3594 0.0538396L14.9844 1.42103C14.4766 1.61634 14.125 2.08509 14.125 2.63196V14.3117C13.3828 13.9601 12.5234 13.7257 11.625 13.7257C9.20312 13.7257 7.25 15.132 7.25 16.8507C7.25 18.6085 9.20312 19.9757 11.625 19.9757C14.0078 19.9757 16 18.6085 16 16.8507V7.63196L20.1016 6.3429C20.6484 6.14759 21 5.67884 21 5.13196V1.22571C21 0.83509 20.8047 0.483527 20.4531 0.249152ZM11.625 18.1007C10.0625 18.1007 9.125 17.2804 9.125 16.8507C9.125 16.421 10.0625 15.6007 11.625 15.6007C13.1484 15.6007 14.125 16.421 14.125 16.8507C14.125 17.3195 13.1484 18.1007 11.625 18.1007ZM19.125 4.66321L16 5.63978V3.10071L19.125 2.08509V4.66321Z"
      fill="white"
    />
    <path
      d="M10.3125 6.625H0.9375C0.390625 6.625 0 6.19531 0 5.6875C0 5.14062 0.390625 4.75 0.9375 4.75H10.3125C10.8203 4.75 11.25 5.14062 11.25 5.6875C11.25 6.19531 10.8203 6.625 10.3125 6.625Z"
      fill="white"
    />
    <path
      d="M6.375 0.9375L6.375 10.3125C6.375 10.8594 5.98438 11.25 5.4375 11.25C4.92969 11.25 4.5 10.8594 4.5 10.3125L4.5 0.9375C4.5 0.429688 4.92969 -1.87822e-08 5.4375 -4.09794e-08C5.98437 -6.48841e-08 6.375 0.429687 6.375 0.9375Z"
      fill="white"
    />
  </svg>
);
